// NorthLine wordmark — inline SVG for crisp rendering at any size.
// "NORTH" navy + "LINE" orange, orange arc above, tagline below.
export function Logo({ variant = "dark", showTagline = false, className = "" }) {
  const navy = variant === "light" ? "#0F1A3A" : "#E7ECFF";
  const navyStrong = "#1E3A8A";
  const orange = "#FF5A00";
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="northline-logo">
      <svg
        viewBox="0 0 260 90"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="NorthLine — Supply Chain, Simplified."
        className="h-9 sm:h-10 w-auto"
        style={{ overflow: "visible" }}
      >
        {/* Orange curved arc sweeping over the wordmark, tapered start */}
        <path
          d="M 50 30 Q 145 -2 240 20"
          fill="none"
          stroke={orange}
          strokeWidth="7"
          strokeLinecap="round"
        />
        {/* Wordmark */}
        <text
          x="18"
          y="60"
          fontFamily="'Space Grotesk', 'Inter', system-ui, sans-serif"
          fontWeight="800"
          fontSize="34"
          letterSpacing="-1"
          fill={variant === "light" ? navyStrong : navy}
        >
          NORTH<tspan fill={orange}>LINE</tspan>
        </text>
        {showTagline && (
          <text
            x="18"
            y="80"
            fontFamily="'Inter', system-ui, sans-serif"
            fontWeight="500"
            fontSize="9"
            letterSpacing="1.5"
            fill={variant === "light" ? "#475569" : "#94a3b8"}
          >
            SUPPLY CHAIN, SIMPLIFIED.
          </text>
        )}
      </svg>
    </div>
  );
}
